/*LIBRARY*/
import { useState, useEffect } from "react";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/
import { clone_project } from "../../App/actions/projectActions";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const CLONE_PROJECT = ({
  project,
  auth,
  clone_project,
  toggle_clone_project,
  toggle_edit_project,
}) => {
  const [state, set_state] = useState({
    new_project_name: "",
    new_project_desc: "",
  });

  const { geo_project } = project;

  useEffect(() => {
    //new_project_name
    if (geo_project) {
      set_state({
        new_project_name: `${geo_project.name} COPY`,
        new_project_desc: `${geo_project.description} COPY`,
      });
    }
  }, [geo_project]);

  const on_change = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    set_state((prev_state) => ({ ...prev_state, [name]: value }));
  };

  const on_clone_project = () => {
    const { new_project_name, new_project_desc } = state;
    const body = {
      geo_project_id: geo_project._id,
      new_project_name,
      new_project_desc,
    };
    clone_project(body);
    toggle_clone_project();
    toggle_edit_project();
  };

  //local storage
  const language = localStorage?.language || auth.language;

  //local state
  const { new_project_name, new_project_desc } = state;

  //global props

  //content

  return (
    <main>
      <h1 className="text_header margin_bottom">
        {dict?.["Clone this project"]?.[language]}
      </h1>
      <p className="text_medium sub_color margin_bottom">
        {
          dict?.[
            "Project details will be duplicated, folders will be duplicated but layer data will not be duplicated."
          ]?.[language]
        }
      </p>
      <br />
      <p className="text_medium sub_color margin_bottom">
        {dict?.["Project name"]?.[language]}
      </p>
      <input
        name="new_project_name"
        value={new_project_name}
        onChange={on_change}
        data-mapid="inputProjectName"
        className="margin_bottom_extra"
      />
      <p className="text_medium sub_color margin_bottom">
        {dict?.["Project description"]?.[language]}
      </p>
      <input
        name="new_project_desc"
        value={new_project_desc}
        onChange={on_change}
        data-mapid="inputProjectDeskription"
        className="margin_bottom_extra"
      />
      <br />
      <button
        className="button background_black"
        onClick={on_clone_project}
        data-mapid="clickSekarang"
      >
        {dict?.["Run the cloning process"]?.[language]}
      </button>
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  project: state.project,
});

export default connect(mapStateToProps, { clone_project })(CLONE_PROJECT);
